module.exports = __webpack_public_path__ + "img/produce.95861d04.png";